import { render, staticRenderFns } from "./FuncionarioList.vue?vue&type=template&id=246c3938"
import script from "./FuncionarioList.vue?vue&type=script&lang=js"
export * from "./FuncionarioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports